import { Component, inject } from '@angular/core';
import { FomentIndexService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  FomentIndexCreateDto,
  FomentIndexDto,
  FomentIndexExcelDownloadDto,
  FomentIndexUpdateDto,
} from '../proxy/controlling/dtos/foment-index';
import { FOMENTINDEX_CONFIG, FOMENTINDEX_FIELDS } from './foment-index.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-foment-index',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, FomentIndexService, ConfirmationService],
  templateUrl: './foment-index.html',
  styleUrl: './foment-index.scss',
})
export class FomentIndex extends BaseCrudComponent<
  FomentIndexDto,
  FomentIndexCreateDto,
  FomentIndexUpdateDto,
  FomentIndexExcelDownloadDto
> {
  service = inject(FomentIndexService);
  config = FOMENTINDEX_CONFIG;
  fields = FOMENTINDEX_FIELDS;

  protected prepareUpdateDto(data: any, selected: FomentIndexDto): FomentIndexUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'FomentIndex';
  }
}
